import React from 'react'

import Layout from '../layout'

const CaliforniaLanding = () => {
  return (
    <>
      <Layout
        cityName="San Francisco"
        marketName="NorCal"
        marketCode="ca"
        signUpToken="b_7b235a0b84e1f694020e638b5_d4752dd791"
        signUpUrl="https://riparide.us2.list-manage.com/subscribe/post?u=7b235a0b84e1f694020e638b5&amp;id=d4752dd791"
      />
    </>
  )
}

export default CaliforniaLanding
